<!--<ara-side-nav #navbar class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>-->
<div class="page-content-wrapper">
	<div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
		<ol class="breadcrumb bc-3"  >
			<li>
			<a [routerLink]="'/home'">Home</a>
			</li>
			<li>
			<a>Performance Dashboard</a>
			</li>
		  </ol>
			<div class="inner-wrapper">
			<div class="sub-wrapper">
				<nav aria-label="breadcrumb">
					<ol class="breadcrumb">
						<li class="breadcrumb-item active" aria-current="page">
							Contractor Statistics Overview
						</li>
						<li class="filter-sort">
							<div class="filter-sort-wrapper" (clickOutside)="onClickedOutside()">
								<a class="settings" data-toggle="collapse" data-target="#filter" (click)="onTabOpen()">
									<i class="fa fa-filter" aria-hidden="true" pTooltip="Filter"
										tooltipPosition="top"></i>
								</a>
								<div class="outer-wrapper" *ngIf="hideFilter">
									<ul class="filter-section-wrapper collapse" id="filter">
										<li>
											<div class="leave-type">
												<h5 class="margin-bottom-10">Unit </h5>
												<p-multiSelect [options]="unitList" [(ngModel)]="selectedUnit">
												</p-multiSelect>
											</div>
										</li>
										<li>
											<div class="leave-type">
												<h5 class="margin-bottom-10">Contractor </h5>
												<p-multiSelect [options]="contractorsList"
													[(ngModel)]="selectedContractorIds"></p-multiSelect>
											</div>
										</li>
										<li>
											<div class="leave-type">
												<h5 class="margin-bottom-10">Status </h5>
												<p-multiSelect [options]="status" [(ngModel)]="selectedStatus">
												</p-multiSelect>
											</div>
										</li>
										<div class="clearfix"></div>
										<li>
											<div class="leave-type">
												<h5>Month Range</h5>
												<div class="col-lg-12 col-md-11 col-sm-11 no-padding margin-top-10">
													<div class="col-lg-6 col-md-6 col-sm-6 no-padding-left">
														<p-calendar [(ngModel)]="dateFrom" view="month"
															dateFormat="mm/yy" [yearNavigator]="true"
															yearRange="2000:2030" placeholder="From"
															(click)="setToYear()"></p-calendar>
													</div>
													<div class="col-lg-6 col-md-6 col-sm-6 no-padding-right">
														<p-calendar [(ngModel)]="dateTo" view="month" dateFormat="mm/yy"
															[yearNavigator]="false" placeholder="To"
															[minDate]="minDateValue" [maxDate]="maxDateValue"
															[readonlyInput]="true"></p-calendar>
													</div>
													<div class="clearfix"></div>
												</div>
												<div class="clearfix"></div>
											</div>
										</li>
										<div class="clearfix"></div>
										<li class="filter-footer">
											<footer>
												<a (click)="resetFilter()" role="button"
													class="btn btn-primary primary-btn button-reset">
													<i class="fa fa-refresh"></i>Reset

												</a>
												<a (click)="doneFilter()" role="button"
													class="btn btn-primary primary-btn button-submit">
													<i class="fa fa-check"></i>Done
												</a>
											</footer>
										</li>
									</ul>
								</div>
								<a class="settings" data-toggle="collapse" data-target="#sort" (click)="onTabOpen()">
									<i class="fa fa-sort" aria-hidden="true" pTooltip="Sort" tooltipPosition="top"></i>
								</a>
								<div class="outer-wrapper" *ngIf="hideSort">
									<ul class="filter-section-wrapper sort-section-wrapper collapse" id="sort">
										<li>
											<div class="sort-wrapper">
												<div class="dt-sort">
													<label>Id</label>
													<a class="dt-sort">
														<i (click)="ascId()" class="fa fa-long-arrow-up"
															aria-hidden="true"></i>
													</a>
													<a>
													</a>
													<a class="selected">
														<i (click)="descId()" class="fa fa-long-arrow-down"
															aria-hidden="true"></i>
													</a>
												</div>
											</div>
										</li>
										<li>
											<div class="sort-wrapper">
												<div class="dt-sort">
													<label>Submitted By</label>
													<a class="">
														<i (click)="ascSubmittedBy()" class="fa fa-long-arrow-up"
															aria-hidden="true"></i>
													</a>
													<a>
													</a>
													<a class="selected">
														<i (click)="descSubmittedBy()" class="fa fa-long-arrow-down"
															aria-hidden="true"></i>
													</a>
												</div>
											</div>
										</li>
										<li class="no-margin-right">
											<div class="sort-wrapper">
												<div class="dt-sort">
													<label>Unit</label>
													<a class="">
														<i (click)="ascPtwName()" class="fa fa-long-arrow-up"
															aria-hidden="true"></i>
													</a>
													<a>
													</a>
													<a class="selected">
														<i (click)="descPtwName()" class="fa fa-long-arrow-down"
															aria-hidden="true"></i>
													</a>
												</div>
											</div>
										</li>
										<div class="clearfix"></div>
									</ul>
								</div>
							</div>
							<div class="clearfix"></div>
						</li>
					</ol>
				</nav>
				<div class="section-wrapper">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
						<div class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10">
							<a [ngClass]="statisticRecords.length && !disableExport ? 'cursor-pointer' : 'disabled'"
								(click)="statisticRecords.length ? exportToExcel() : $event.preventDefault()"
								class="btn btn-primary primary-btn button-excel" role="button">
								<i class="fa fa-file-excel-o" style="padding-right:10px"></i>
								<ng-container>Export To Excel</ng-container>
							</a>
							<a [ngClass]="statisticRecords.length && !disableExport ? 'cursor-pointer' : 'disabled'"
								(click)="statisticRecords.length ? downloadZIP() : $event.preventDefault()"
								class="btn btn-primary primary-btn button-zip" role="button">
								<i class="fa fa-file-excel-o" style="padding-right:10px"></i>
								<ng-container>Export To ZIP</ng-container>
							</a>
						</div>
						<div class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right">
							<input type="text" [(ngModel)]="searchText" (keyup.enter)="searchData()"
								placeholder="Search" class="form-control search-obs" />
							<button class="btn btn-primary primary-btn">
								<i class="fa fa-search search" [class.padding]="searchText.length>0"
									(click)="searchData()"></i>
								<i class="fa fa-close clear" *ngIf="searchText.length>0" (click)="clearSearch()"></i>
							</button>
						</div>
						<div class="clearfix"></div>
					</div>
					<div class="clearfix"></div>
					<div class="table-responsive margin-top-15 ">
						<table align="center" class="table table-bordered table-striped table-condensed">
							<thead>
								<tr>
									<th style="width: 50px">
										<input type="checkbox" [checked]="isCSChecked" [(ngModel)]="isCSChecked"
											(change)="selectAllStatisticRequests($event.target.checked)"
											[value]="isCSChecked">
									</th>
									<th>Contractor Statistic ID</th>
									<th>Unit</th>
									<th>Submitted By</th>
									<th>Contract Holder</th>
									<th>Approver</th>
									<th>Contract Number</th>
									<th>Status</th>
									<th>Reported Month</th>
									<th style="width: 50px">Download</th>
									<th style="width: 50px" *ngIf="independentPermissions.SUPER_Admin" >Action</th>
  
								</tr>
							</thead>
							<tbody>
								<tr (contextmenu)="cm.show($event);showContextMenu(statisticRecord)" #row
									style="cursor:pointer;"
									*ngFor='let statisticRecord of statisticRecords | paginate: { itemsPerPage: itemPerPage, currentPage: pageSize ,totalItems: rowCount}'
									id={{statisticRecord.statisticId}}>
									<td>
										<span *ngIf="statisticRecord.status ==='Draft'">
											<input type="checkbox" [disabled]="statisticRecord.status==='Draft'"
											(change)="selectStatisticRequests(statisticRecord,$event)"
											[value]="statisticRecord">
										</span>
										<span *ngIf="statisticRecord.status !=='Draft'">
                                            <input type="checkbox" [(ngModel)]="statisticRecord.Checked"
											[checked]="statisticRecord.Checked"
											(change)="selectStatisticRequests(statisticRecord,$event)"
											[value]="statisticRecord">
										</span>
										
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)"
										[routerLink]="['/pd/statistic/', statisticRecord.statisticId,{unitId :statisticRecord.unitId}]">
										<span *ngIf="statisticRecord.status ==='Draft'" style="color:red">Draft</span>
								        <span *ngIf="statisticRecord.status !=='Draft'">CS{{statisticRecord.statisticId}}</span>
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)" [routerLink]="['/pd/statistic/', (statisticRecord.statisticId),
										{unitId :statisticRecord.unitId}]">
										{{statisticRecord.unitName}}
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)" [routerLink]="['/pd/statistic/', (statisticRecord.statisticId),
										{unitId :statisticRecord.unitId}]">
										{{statisticRecord.submittedBy}}
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)" [routerLink]="['/pd/statistic/', (statisticRecord.statisticId),
										{unitId :statisticRecord.unitId}]">
										{{statisticRecord.contractHolderName}}
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)" [routerLink]="['/pd/statistic/', (statisticRecord.statisticId),
										{unitId :statisticRecord.unitId}]">
										{{statisticRecord.approvedRejectedByName}}
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)" [routerLink]="['/pd/statistic/', (statisticRecord.statisticId),
										{unitId :statisticRecord.unitId}]">
										{{statisticRecord.contractNo}}
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)" [routerLink]="['/pd/statistic/', (statisticRecord.statisticId),
										{unitId :statisticRecord.unitId}]">
										{{statisticRecord.status}}
									</td>
									<td (click)="getCurrentDOMElementId(statisticRecord.statisticId)" [routerLink]="['/pd/statistic/', (statisticRecord.statisticId),
										{unitId :statisticRecord.unitId}]">
										{{statisticRecord.reportedMonth | dateTimeFormat: "MMM, YYYY"}}
									</td>
									<td style="text-align: center;">
										<i (click)="downloadPDF(statisticRecord.statisticId)"
											class="fa fa-download"></i>
									</td>

									<td *ngIf="independentPermissions.SUPER_Admin">
										<ara-record-actions *ngIf="statisticRecord.status === 'Deleted'" [SourceId]="statisticRecord.statisticId" ModuleName="ContractorStatistics" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >
										</ara-record-actions>
									   </td>
								</tr>
							</tbody>
						</table>
						<div *ngIf="!statisticRecords.length" style="width: 500px;margin-top:15px;color: red">
							No Records Found
						</div>
						<div style="width: 500px" *ngIf="(statisticRecords.length > 1)">
							<pagination-controls (pageChange)="getServerData($event)"></pagination-controls>
						</div>
					</div>
					<div class="clearfix"></div>
					<p align="right">
						<button type="button" routerLink="/pd/dashboard" class="btn btn-primary primary-btn button-back">
							<i class="fa fa-reply"></i> Back to Performance Dashboard
						</button>
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="clearfix"></div>
</div>
<p-contextMenu [appendTo]="row" [target]="row" #cm [model]="contextItems"></p-contextMenu>